import { render, staticRenderFns } from "./alterarsenha.vue?vue&type=template&id=61e60cfa"
import script from "./alterarsenha.ts?vue&type=script&lang=js&external"
export * from "./alterarsenha.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61e60cfa')) {
      api.createRecord('61e60cfa', component.options)
    } else {
      api.reload('61e60cfa', component.options)
    }
    module.hot.accept("./alterarsenha.vue?vue&type=template&id=61e60cfa", function () {
      api.rerender('61e60cfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/crud/alterarsenha/alterarsenha.vue"
export default component.exports